import React from "react"

import DashboardPlaceholder from "../../../components/utilityComponents/placeholders/DashboardPlaceholder"

// Dashboards are being retired. The data views — and the GET /clients/:id/dashboard and
// GET /clients/:id/client_utility_services calls behind them — are disabled following the
// Jul 28-29 CPU incident. Previous implementation is in git history; the orphaned
// components under src/features/dashboards/ are removed in a follow-up ticket.
export default function Dashboard() {
    return <DashboardPlaceholder />
}
